
<app-form-input 
[parentForm]="parentForm"
 
[label]="step2.getspan1"
[type]="'radio'"
[disabled]="disabled"
[rule]="'pattern_29|required'"
[errorMessage]="{'required' : 'ctr_1118'}"
[value]="radioButtonValue"
[name]="radioButtonCtrlName"
[radios]="[
						{
                            value: siretValue,
							label: step2.getsiret
						},
                        {
                            value: sirenValue,
							label: step2.getsiren
						},
                        {
                            value: ridetValue,
							label: step2.getridet
						},
                        {
                            value: tahitiValue,
							label: step2.gettahiti
						},
                        {
                            value: frwfValue,
							label: step2.getfrwf
						},{
                            value: irepValue,
							label: step2.getirep
						},{
                            value: tvaIntraValue,
							label: step2.gettvaintra
						}
]">
</app-form-input>

<!--<app-form-input 
[parentForm]="parentForm" 
[value]="typeIdentificationNational.siren" 
 
[label]="step2.getsiren"
[type]="'text'"
[disabled]="disabled"
     [rule]="''"
[name]="getUid()+'_SepAtt_siren'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm" 
[value]="typeIdentificationNational.ridet" 
 
[label]="step2.getridet"
[type]="'text'"
[disabled]="disabled"
     [rule]="''"
[name]="getUid()+'_SepAtt_ridet'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm" 
[value]="typeIdentificationNational.tahiti" 
 
[label]="step2.gettahiti"
[type]="'text'"
[disabled]="disabled"
     [rule]="''"
[name]="getUid()+'_SepAtt_tahiti'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm" 
[value]="typeIdentificationNational.frwf" 
 
[label]="step2.getfrwf"
[type]="'text'"
[disabled]="disabled"
     [rule]="''"
[name]="getUid()+'_SepAtt_frwf'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm" 
[value]="typeIdentificationNational.irep" 
 
[label]="step2.getirep"
[type]="'text'"
[disabled]="disabled"
     [rule]="''"
[name]="getUid()+'_SepAtt_irep'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm" 
[value]="typeIdentificationNational.tvaIntra" 
 
[label]="step2.gettvaintra"
[type]="'text'"
[disabled]="disabled"
     [rule]="''"
[name]="getUid()+'_SepAtt_tvaIntra'">
</app-form-input>-->